import { z } from "zod";
import { allowedDomainSchema } from "./allowedDomain.js";
const secretIdSchema = z.uuid().brand();
function asSecretId(id) {
  return secretIdSchema.parse(id);
}
const secretMaxAllowedDomainCount = 20;
const secretAllowedDomainsSchema = z.array(allowedDomainSchema).min(1, "Add at least one domain the secret may be sent to.").max(
  secretMaxAllowedDomainCount,
  `Add no more than ${secretMaxAllowedDomainCount.toString()} allowed domains.`
).transform((domains) => Array.from(new Set(domains)));
const secretSettingsSchema = z.object({
  allowed_domains: secretAllowedDomainsSchema
});
const secretValueMinLength = 4;
const secretValueMaxLength = 4096;
const secretPatchPayloadSchema = z.object({
  value: z.string().min(secretValueMinLength).max(secretValueMaxLength),
  allowed_domains: secretAllowedDomainsSchema
});
const secretNameSchema = z.string().max(64).regex(/^[A-Z][A-Z0-9_]*$/u, {
  message: "Secret names must start with a letter and use capitals, digits and underscores."
});
function formatSecretName(name) {
  return name.toUpperCase().replace(/[\s-]/gu, "_");
}
const secretPostPayloadSchema = secretPatchPayloadSchema.extend({
  name: secretNameSchema
});
export {
  asSecretId,
  formatSecretName,
  secretAllowedDomainsSchema,
  secretIdSchema,
  secretNameSchema,
  secretPatchPayloadSchema,
  secretPostPayloadSchema,
  secretSettingsSchema,
  secretValueMaxLength,
  secretValueMinLength
};
//# sourceMappingURL=secret.js.map
